import classNames from "classnames";
import type { GlideFC } from "lib/glide-fc";
import type { FormElementProps } from "../form-element/form-element";
import FormElement from "../form-element/form-element";
import { RadioButtonsStyle, RadioButtonStyle } from "./radio-buttons-style";

interface Props extends FormElementProps {
    items: readonly string[];
    current: readonly number[];
    isMulti: boolean;

    className?: string;

    onClick: (index: number) => void;
    formatItem?: (item: string) => string;
}

const RadioButtonsView: GlideFC<Props> = props => {
    const { className, items, current, onClick, formatItem, isMulti } = props;

    const children = items.map((val, index) => {
        const isSelected = current.indexOf(index) !== -1;
        return (
            <RadioButtonStyle
                className={classNames({
                    current: isSelected,
                })}
                key={index}>
                <input
                    type={isMulti ? "checkbox" : "radio"}
                    name={val}
                    checked={isSelected}
                    onChange={e => {
                        e.stopPropagation();
                        onClick(index);
                    }}
                />
                <span className="label">{formatItem === undefined ? val : formatItem(val)}</span>
            </RadioButtonStyle>
        );
    });

    return (
        <FormElement {...props}>
            <RadioButtonsStyle className={className}>{children}</RadioButtonsStyle>
        </FormElement>
    );
};

export default RadioButtonsView;
